// extracted by mini-css-extract-plugin
export default {"cmsFooterMainTextWrapper":"CmsFooterMainTextEditModal_cmsFooterMainTextWrapper__jAMr4"};